<script setup>
/*
    Metric Table widget

    Components:
        primary: <vu-table>

    Widget Properties:
        value: []

    Component Args

    CSS Properties:
 */
import {reactive, ref} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

defineExpose({update})

const props = defineProps({
    buttons: Array,
    dashboard: Object,
    state: Object,
    widget: Object,
})

const page = reactive({
    args: {},
    data: null,
    fields: null,
    loading: null,
    select: null,
})

const Fields = [
    {name: 'dimension'},
    {name: 'value', title: 'Value', format: (v) => v.toLocaleString()},
]

const primary = ref(null)

async function update() {
    let widget = props.widget
    let data = widget.value.map((i) => {
        return {
            dimension: makeDimensionString(i.dimensions),
            value: i.points[0]?.value,
        }
    })
    Object.assign(page, getWidgetProps(widget, {primary}, {data, multipoint: true}))
    for (let item of page.data.primary) {
        item.value = +item.value.toFixed(0)
    }
}

function makeDimensionString(dimensions) {
    let result = []
    let entries = Object.entries(dimensions).sort((a, b) => a[0].localeCompare(b[0]))
    for (let [name, value] of entries) {
        result.push(`${name}=${value}`)
    }
    return result.join(',')
}

function buttonClick() {}
function clicked() {}
</script>

<template>
    <vu-table
        class="metric-table-widget"
        options="filter,toolbar"
        ref="primary"
        width="100%"
        :data="page.data?.primary"
        :fields="page.fields || Fields"
        :nodata="page.loading ? 'Loading...' : 'No Items'"
        :name="widget.subtitle"
        :pageSize="widget.pageSize"
        :pivot="widget.pivot"
        :select="page.select"
        :title="widget.subtitle"
        sort="value:desc"
        @click="clicked"
        @reload="update">
        <template v-slot:more="props">
            <v-btn
                v-for="(btn, index) in buttons"
                class="mr-2"
                :color="index == 0 ? 'accent' : ''"
                :variant="index > 0 ? 'outlined' : 'elevated'"
                :key="btn"
                @click="buttonClick(btn)">
                {{ btn }}
            </v-btn>
        </template>
    </vu-table>
</template>

<style lang="scss">
.metric-table-widget {
    padding: 40px 20px 20px 20px;
    font-size: 1rem;
    .table-title {
        font-size: 1.4rem !important;
        padding-top: 5px;
    }
    .table-data {
        width: 100%;
    }
}
</style>
